import { Grid } from "@material-ui/core";

const DeviceInfo = ({ deviceInfo }) => {
  const headers = [
    { title: "نام دستگاه", data: "deviceName" },
    { title: "نام پروژه", data: "projectName" },
    { title: "نوع دستگاه", data: "deviceType" },
    { title: "دسته دستگاه", data: "deviceCategory" },
    { title: "سریال دستگاه", data: "deviceSerial" },
    { title: "نام مالک", data: "ownerName" },
    { title: "شماره مالک", data: "ownerPhone" },
  ];
  const infoData = {
    deviceName: deviceInfo?.water_meter_name,
    projectName: deviceInfo?.water_meter_project_info?.project_name,
    deviceType: deviceInfo?.water_meter_type_info?.water_meter_type_name,
    deviceCategory: deviceInfo?.water_meter_tag_info?.water_meter_tag_name,
    deviceSerial: deviceInfo?.water_meter_serial,
    ownerName:
      deviceInfo?.water_meter_user_info?.user_name +
      deviceInfo?.water_meter_user_info?.user_lastname,
    ownerPhone: deviceInfo?.water_meter_user_info?.user_phone,
  };
  return (
    <>
      {headers.map((item, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ padding: "5px 15px" }}
        >
          <span style={{ fontWeight: "600", marginLeft: "8px" }}>
            {item.title} :{" "}
          </span>{" "}
          <span>{infoData[item.data]}</span>
        </Grid>
      ))}
    </>
  );
};
export default DeviceInfo;
